
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle, runWithConsole} = await import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("runWithConsole" in module)) throw new SyntaxError(`export 'runWithConsole' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, consoleOutput } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,runWithConsole,codeEditor,consoleOutput};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","runWithConsole","codeEditor","consoleOutput"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-4`),
    expanded: [],
    variables: []
  },
  {
    id: 4,
    body: (view,codeEditor) => {
const demo = view(codeEditor("comments:demo", {
  value: '// Hier passiert die Begrüßung\nconst name = "Anna" // der Name der Person\nconsole.log("Hallo, " + name + "!")\n\n// const ungenutzt = "wird nie ausgeführt"\n// console.log("Auch das hier ist auskommentiert")'
}));
return {demo};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: async (display,consoleOutput,runWithConsole,demo) => {
display(consoleOutput(await runWithConsole(demo)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-7`),
    expanded: [],
    variables: []
  },
  {
    id: 7,
    body: (view,codeEditor) => {
const demo_q = view(codeEditor("comments:quartal", {
  value: 'const month = 8\n// Quartal als String\nlet quarter\nif (month < 4) {\n  // Januar bis März\n  quarter = "Q1"\n} else if (month < 7) {\n  // April bis Juni\n  quarter = "Q2"\n} else if (month < 10) {\n  // Juli bis September\n  quarter = "Q3"\n} else if (month < 13) {\n  // Oktober bis Dezember\n  quarter = "Q4"\n} else {\n  // Monate über 12 machen keinen Sinn...\n  console.log("Das ist kein Monat...")\n}\n// Gib das Quartal aus, wird undefined ausgeben wenn der Monat auf > 12 gesetzt war\nconsole.log(quarter)'
}));
return {demo_q};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_q"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-8`),
    expanded: [],
    variables: []
  },
  {
    id: 8,
    body: async (display,consoleOutput,runWithConsole,demo_q) => {
display(consoleOutput(await runWithConsole(demo_q)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_q"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
